<template>
  <article class="faq">
    <h3 class="question">
      <picture>
        <source :srcset="image" media="(min-width: 768px)">
        <source :srcset="imageSp" media="(max-width: 767px)">
        <img :src="image" :alt="question"><br>
      </picture>
    </h3>
    <div class="answer">
      <p>
        {{answer}}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'staffFaqLink',
  props: {
    image: {
      type: String,
      default: "",
    },
    imageSp: {
      type: String,
      default: "",
    },
    question: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.faq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 100px;
  opacity: 0;
  transform: translateY(100px);
  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1) 0.1s;
  @media print,screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 50px;
  }
  &.is-show {
    opacity: 1;
    transform: translateY(0px);
  }
  .question {
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    @media print,screen and (min-width: 768px) {
      width: 40%;
      padding: 0 60px;
    }
    img {
      width: 100%;
      @media print,screen and (max-width: 767px) {
        height: 70px;
        width: auto;
        margin: auto;
      }
    }
  }
  &:nth-of-type(even) {
    @media print,screen and (min-width: 768px) {
      flex-direction: row-reverse;
    }
    .answer {
      // &:before {
      //   @media print,screen and (min-width: 768px) {
      //     border-right: 0!important;
      //     border-left: 20px solid #3fae00;
      //     right: -22px;
      //     left: auto!important;
      //   }
      // }
    }
  }
  .answer {
    max-width: 620px;
    width: 100%;
    border: 5px dotted #3fae00;
    box-sizing: border-box;
    font-size: 15px;
    border-left: 5px dotted #3fae00;
    padding: 20px;
    position: relative;
    white-space: pre-line;
    // &:before {
    //   content: "";
    //   width: 0;
    //   height: 0;
    //   border: 20px solid transparent;
    //   position: absolute;
    //   @media print,screen and (min-width: 768px) {
    //     border-right: 20px solid #3fae00;
    //     left: -42px;
    //     top: 50%;
    //     transform: translateY(-50%);
    //   }
    //   @media print,screen and (max-width: 767px) {
    //     left: 0;
    //     right: 0;
    //     margin: auto;
    //     border-bottom: 20px solid #3fae00;
    //     top: -40px;
    //   }
    // }
    p {
      margin: 0;
    }
  }
}
</style>
